import { forwardRef, type ChangeEvent, type ComponentProps } from 'react';
import { Input } from '@/shared/ui/inputs/Input';
import { sanitizeDecimalInput } from '@/shared/utils/number';

type NumberInputProps = ComponentProps<typeof Input>;

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(function NumberInput(
  { onChange, inputMode = 'decimal', ...rest },
  ref,
) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizeDecimalInput(event.target.value);
    if (sanitized !== event.target.value) {
      event.target.value = sanitized;
    }
    onChange?.(event);
  };
  return <Input ref={ref} inputMode={inputMode} onChange={handleChange} {...rest} />;
});
